import { Select } from "antd";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useTenantCategorySelectOptions } from "components/UI/Selects/TenantCategorySelectSearchable/useTenantCategorySelectOptions.ts";

export const TenantCategorySelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useTenantCategorySelectOptions();

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.tenant_category"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
